<section class="card">

    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">SH-3 Register of Sweat Equity Shares</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/sh-3/add"> -->
          <button (click)="addsh3()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
          [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    
  
  
        
         
              <!-- Date Filter  -->
              <section class="card search-box">
                <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span
                    class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
                <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
                  <div class="row">
                    <div class="col-lg-12">
  
                      
                        <div class="row">
                         
                          <div class="col-md-3">
                            <label>Folio No. </label>
                            <div class="input-group">
                            <input type="text" class="form-control" name="folioNo" [(ngModel)]="folioNo">
                          </div>
                        </div>
  
                        <div class="col-md-3">
                          <label>Status</label>
                          <select class="form-control" style="padding:6px;" [(ngModel)]="statusOfAllotee">
                            <option value="" [selected]="true">Select any one</option>
                            <option value="Director">Director</option>
                            <option value="Employee">Employee</option>
                          </select>
                        </div>
  
                            
                          <!-- <div class="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label>Date of issue of sweat equity shares</label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="dateOfIssueOfSweat" class="form-control" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" name="dateOfIssueOfSweat" ngbDatepicker #b="ngbDatepicker"
                                (click)="b.toggle()" [(ngModel)]="dateOfIssueOfSweat">
                              <button class="input-group-addon" (click)="b.toggle()" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div> -->
  
                          <div class="col-md-3">
                            <br>
                            <!-- <label>Date of issue of sweat equity shares</label> -->
                            <div class="input-group" (click)="$event.stopPropagation()">
                              From:&nbsp;
                              <input id="dateOfIssueOfSweat" class="form-control" [minDate]="futureToDate"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfIssueOfSweat" ngbDatepicker
                                #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfIssueOfSweat">
                              <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
  
  
                          <div class="col-md-3">
                
                            <br>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              To:&nbsp;
                              <input id="dateOfIssueOfSweatTo" class="form-control" [minDate]="futureToDate"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfIssueOfSweatTo" ngbDatepicker
                              #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfIssueOfSweatTo">
                            <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                            </div>
                          </div>
                        
  
  
                         
  
                          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label>&nbsp;&nbsp;&nbsp;</label>
                            <div class="input-group">
                              <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                                <i class="fa fa-search"></i>&nbsp;Search</button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                                (click)="clearAdvSearch()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                            </div>
                          </div>
                          
  
                        </div>
                      
  
                    </div>
                  </div>
                </div>
              </section>
              <!-- Date filter End -->
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfSh3" [dtTrigger]="dtTriggerSh3"
                          class="table table-hover compact cell-border nowrap stripe" id="directormasterSh3Table"
                          style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>Folio No</th>
                              <th>Allottee Name</th>
                              <th>Date of Passing <br>of Board resolution</th>
                              <th style="display: none">Date of Passing of Board resolution</th>
                              <th>Number of SES issued</th>
                              <th>Date of issue of <br>sweat equity shares</th>
                              <th style="display: none">Date of issue of sweat equity shares</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let director of registerDirectorList;let i=index">
                              <td tabindex="1">{{director.folioNo}}</td>
                              <td tabindex="1">{{director.nameOfAllotee}}</td>
  
                              <td>
                                <span style="display: none">{{director.dateOfPassingBoardResolution | date : "yMMdd"}}</span>
                                {{director.dateOfPassingBoardResolution | date : "dd-MM-y"}}
                              </td>
                              <td style="display: none">
                                {{director.dateOfPassingBoardResolution | date : "dd-MM-y"}}
                              </td>
  
                             
                              <td tabindex="1">{{director.numberofsweatequitysharesissued}}</td>
  
                              <td>
                                <span style="display: none">{{director.dateOfIssueOfSweat | date : "yMMdd"}}</span>
                                {{director.dateOfIssueOfSweat | date : "dd-MM-y"}}
                              </td>
                              <td style="display: none">
                                {{director.dateOfIssueOfSweat | date : "dd-MM-y"}}
                              </td>
                             
                              <td style='white-space: nowrap'>
                                <a>
                                  <button type="button" (click)="editSh3Details(director._id)" class="btn-sm btn btn-warning" 
                                  [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
                                    <span class="fa fa-pencil"></span>
                                  </button>
                                </a>
                                <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)"
                                [appHasPermission]="{'Url': '/register/sh3List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh3List'}">
                                  <span class="icmn-bin"></span>
                                </button>
                              </td>
                          
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
            </section>
  
            <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
              style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete Sh-3 details?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteSh3Data()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <app-alert></app-alert>